module.exports = __webpack_public_path__ + "media/post-listing-block-3-image@2x.7c8e3589.webp";